import { ArrowLeft } from 'lucide-react';

interface TermsScreenProps {
  onBack: () => void;
}

export const TermsScreen = ({ onBack }: TermsScreenProps) => {
  return (
    <div className="min-h-screen bg-[#F7F8FA]">
      {/* Header */}
      <div className="bg-white border-b border-[#E5E7EB] sticky top-0 z-10">
        <div className="flex items-center gap-3 p-4">
          <button
            onClick={onBack}
            className="w-10 h-10 flex items-center justify-center rounded-full hover:bg-[#F7F8FA] transition-colors"
          >
            <ArrowLeft className="w-6 h-6 text-[#111827]" />
          </button>
          <h1 className="text-lg font-bold text-[#111827]">Términos y condiciones</h1>
        </div>
      </div>

      {/* Content */}
      <div className="p-4 pb-8">
        <div className="bg-white rounded-[16px] border border-[#E5E7EB] p-6 space-y-6">
          <div>
            <p className="text-xs text-[#6B7280] mb-4">
              Última actualización: 15 de enero de 2026
            </p>
            <p className="text-sm text-[#6B7280] leading-relaxed">
              Bienvenido a Mexmo. Al acceder y utilizar nuestra plataforma, aceptas los siguientes términos y condiciones.
            </p>
          </div>

          <div className="space-y-4">
            <div>
              <h3 className="font-bold text-[#111827] mb-2">1. Uso del servicio</h3>
              <p className="text-sm text-[#6B7280] leading-relaxed">
                Mexmo es una plataforma de intermediación para la compra de boletos de autobús. No somos operadores de transporte, sino un servicio que conecta a pasajeros con líneas de autobús autorizadas.
              </p>
            </div>

            <div>
              <h3 className="font-bold text-[#111827] mb-2">2. Registro de cuenta</h3>
              <p className="text-sm text-[#6B7280] leading-relaxed">
                Para utilizar nuestros servicios, debes crear una cuenta proporcionando información precisa y actualizada. Eres responsable de mantener la confidencialidad de tu contraseña y de todas las actividades realizadas bajo tu cuenta.
              </p>
            </div>

            <div>
              <h3 className="font-bold text-[#111827] mb-2">3. Compra de boletos</h3>
              <p className="text-sm text-[#6B7280] leading-relaxed">
                Al comprar un boleto a través de Mexmo, estás aceptando los términos de servicio de la línea de autobús correspondiente. Los precios mostrados incluyen todos los cargos aplicables. La confirmación de compra se enviará por correo electrónico.
              </p>
            </div>

            <div>
              <h3 className="font-bold text-[#111827] mb-2">4. Cancelaciones y reembolsos</h3>
              <p className="text-sm text-[#6B7280] leading-relaxed">
                Las cancelaciones están sujetas a nuestras políticas de cancelación. Los reembolsos se procesarán según el tiempo de cancelación y las políticas de la línea de autobús. Consulta nuestra sección de Políticas de Cancelación para más detalles.
              </p>
            </div>

            <div>
              <h3 className="font-bold text-[#111827] mb-2">5. Responsabilidad</h3>
              <p className="text-sm text-[#6B7280] leading-relaxed">
                Mexmo no se hace responsable por retrasos, cancelaciones o cambios en los horarios de viaje realizados por las líneas de autobús. Nuestra responsabilidad se limita a facilitar la compra y gestión de boletos.
              </p>
            </div>

            <div>
              <h3 className="font-bold text-[#111827] mb-2">6. Modificaciones</h3>
              <p className="text-sm text-[#6B7280] leading-relaxed">
                Nos reservamos el derecho de modificar estos términos en cualquier momento. Las modificaciones entrarán en vigor inmediatamente después de su publicación en la plataforma.
              </p>
            </div>

            <div>
              <h3 className="font-bold text-[#111827] mb-2">7. Contacto</h3>
              <p className="text-sm text-[#6B7280] leading-relaxed">
                Si tienes preguntas sobre estos términos, contáctanos en soporte@mexmo.com
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
